export default "__VITE_ASSET__DAgd0PJy__"